import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MalidCard from './MalidCard';

class OrdsifjabokView extends Component {
	render() {
		return (
			<MalidCard title={window.l('ordsifjabok_title')}
				subTitle={window.l('ordsifjabok_subtitle')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				aboutText={window.l('ordsifjabok_about')}
				database="ordsifjabok">
				{
					this.props.data && this.props.data.map(function(item, index) {
						return <React.Fragment key={index}>
							{
								index > 0 && <hr/>
							}
							<p className="card-text font-andron" key={index} dangerouslySetInnerHTML={{__html: item.faersla_html}} />
						</React.Fragment>
					})
				}
			</MalidCard>
		);
	}
}

export default OrdsifjabokView;



// WEBPACK FOOTER //
// ./src/components/OrdsifjabokView.js